declare var swal: any;
import { Component, ViewEncapsulation, Input, ChangeDetectionStrategy, OnInit, ViewChild } from '@angular/core';
import { NgbModal, ModalDismissReasons, NgbActiveModal, NgbModalRef, NgbDateStruct, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
//import { FileUploader } from 'ng2-file-upload/ng2-file-upload';
import { ApiResponseModel } from '../../../../models/api_response_model';
import { ApiRequestModel } from '../../../../models/api_request_model';
import { SpinnerService } from '../../../../services/spinner.service';
import { AppData } from '../../../../models/appdata';
import { NgForm } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';

//import { DBOperation } from '../../../../../enums/enum';
import { ActorEmploymentPreferencesRequest, ActorContactInfoRequest, EmergencyContactInfoRequest, SaveEmergencyContactInfoRequest } from '../../../../models/profileinfo/profileinfo.model';
import { HCPService } from '../../../../services/hcp.service';


import * as alertFunctions from '../../../../../shared/data/sweet-alerts';
import { NGXToastrService } from '../../../../../shared/services/toastr.service';
import { ServiceConsultantMapController, ServiceDetailsByCodeController, ServiceDetailsByCodeRequest, ServiceBranchMapByServiceCodeController, ServiceBranchMapByServiceCodeRequest, SaveIahOrderStatusRequest, SaveIahOrderItemStatusRequest } from '../../../../models/actor/actor';
import { ServiceConsultantMapRequest } from '../../../../models/actor/actor';
import { ActorService } from '../../../../services/actor.service';
import { CustomCodeTypeRequest_, CustomCodeValuesController_ } from '../../../../models/master/mastermodel';
import { FDService } from '../../../../services/fd.service';
import { ConsultantMapPipe } from '../../../../pipes/actors/actorIdentity.pipes';
import { parse } from 'querystring';
import { Time } from '@angular/common';

@Component({
  selector: 'ngbedititems',
  templateUrl: './edititems.modal.html',
  styleUrls: ['./edititems.modal.scss']
})

export class NgbEditItemsModal implements OnInit {
  @ViewChild('f') IdentitiesForm: NgForm;
    @Input() ModelType: string;
    @Input() CustomerName: string;
    @Input() OrderCode: number;
    @Input() Address: string;
    @Input() OrderDate: Date;
    @Input() CreUser: string;
    @Input() Status: string;
    @Input() Date: Date;
    @Input() ScheduleDate: Date;
    @Input() AssignedNmae: string;
    @Input() ScheduleTime: Time;
    @Input() OrderStatus: string;
    @Input() Comments: string;
    @Input() ServiceName: string;
    @Input() ItemCode: number;
    //public Commentsnew: string;
    SelectedFromDate: NgbDateStruct;
    TodayDate = new Date();
    public ActorCode: number = 0;
    public FacilityCode: number;
    SelectedDate: NgbDateStruct;
  //@Input() IsShowDetail: boolean = false;
  //@Input() CurrentActorEditEmergencyInfoRequest: EmergencyContactInfoRequest;
  //@Input() ServiceCode: number;
    @Input() CurrentSaveIahOrderItemStatusRequest: SaveIahOrderItemStatusRequest;
  searchTitle: string;
  public ApiResData: ApiResponseModel;
    CurrentSaveIahOrderStatusRequest: SaveIahOrderStatusRequest;
    //CurrentSaveIahOrderItemStatusRequest: SaveIahOrderItemStatusRequest;
  public isRequesting: boolean = false;
  public ShowService: boolean = true;
  //public IsSelected: boolean;
  constructor(public activeModal: NgbActiveModal, private loaderService: SpinnerService,
    private actorservice: ActorService, private fdservice: FDService, private filter: ConsultantMapPipe,
    private router: Router, private route: ActivatedRoute, private hcpservice: HCPService,
      private tosterservice: NGXToastrService, private parserFormatter: NgbDateParserFormatter) { }
  ngOnInit() {
      this.FacilityCode = AppData.Instance().SelectedBranchCode;
    this.ShowService = false;
      this.CurrentSaveIahOrderStatusRequest = new SaveIahOrderStatusRequest();
     // this.CurrentSaveIahOrderItemStatusRequest = new SaveIahOrderItemStatusRequest();
      this.CurrentSaveIahOrderStatusRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
      //this.CurrentSaveIahOrderItemStatusRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
      this.SelectedFromDate = { year: this.TodayDate.getFullYear(), month: this.TodayDate.getMonth() + 1, day: this.TodayDate.getDate() };

    this.LoadRegistries();
      if (this.Date != null) {
          var SValidFrom = new Date(this.Date);
          if (SValidFrom.getFullYear() > 1900) {
              console.log('this.UpdateDate >1990');
              this.SelectedDate = {

                  year: SValidFrom.getFullYear(),
                  month: SValidFrom.getMonth() + 1,
                  day: SValidFrom.getDate()
              }
          }
      }

  }




  LoadRegistries() {
    this.StartRefreshing();



    //this.GetBranchMap();


  }



  //onSubmit() {

  //  this.StartRefreshing();
  //  //alert(this.CurrentActorEmploymentPreferencesRequest.ReasonForAccommodation);
  //  this.CurrentActorEditEmergencyInfoRequest.ConditionalOperator = 20;
  //  this.hcpservice.SaveEmergencyContactInfo(this.CurrentActorEditEmergencyInfoRequest)
  //    .subscribe((result) => {
  //      this.ApiResData = result;
  //      if (!this.ApiResData.hasError) {

  //        if (this.ApiResData.Result > 0) {
  //          this.ShowService = false;
  //          //alertFunctions.AlertParam('Saved Successfully.....!');
  //          this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');

  //          this.activeModal.close();

  //          this.stopRefreshing();
  //        }
  //        else {
  //          alertFunctions.AlertParam("Invalid Operation...!");
  //          this.activeModal.close();

  //          this.stopRefreshing();

  //        }

  //      }
  //      else {
  //        this.stopRefreshing();
  //        if (this.ApiResData.ErrorData != "") {

  //          alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
  //          this.activeModal.close();


  //        }
  //        else {
  //          alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
  //          this.activeModal.close();
  //        }
  //      }

  //    },


  //      (error) => {

  //        if (error == "401 - Unauthorized") {
  //          alertFunctions.AlertParamEr(error);
  //          this.activeModal.close();
  //          this.stopRefreshing();



  //        }
  //        else {
  //          alertFunctions.AlertParamEr(error);
  //          this.activeModal.close();
  //          this.stopRefreshing();
  //        }
  //      }
  //    );

  //}
    onAssignedToActorCodesurgeon(event: any) {

        if (event != null) {
            //    if (this.CurrentSaveCounsellingPlanRequest.BranchCode > 0) {
            this.CurrentSaveIahOrderItemStatusRequest.AssignedToName = event;
            //this.CurrentSaveIahOrderItemStatusRequest.ProviderCode = event;
            // console.log('event--_>' + event);
            //   }
        }

    }

    onSubmitOrder() {
        


        this.CurrentSaveIahOrderStatusRequest.UserName = AppData.Instance().UserLoginDetails.DisplayName;
        this.CurrentSaveIahOrderStatusRequest.ConditionalOperator = 10;
        this.CurrentSaveIahOrderStatusRequest.IahOrderCode = this.OrderCode;
        this.CurrentSaveIahOrderStatusRequest.Timestamp = new Date();

        this.actorservice.SaveIahOrderStatus(this.CurrentSaveIahOrderStatusRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {

                    if (this.ApiResData.Result > 0) {
                        //this.GetActorEducationInfoController();
                        //this.GetResourceIdentificationByDateInfoController();
                        // alertFunctions.AlertParam('Saved Successfully.....!');
                        this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
                        //this.isvisible = false;
                        this.activeModal.close();

                        this.stopRefreshing();
                    }
                    else {
                        alertFunctions.AlertParam("Invalid Operation...!");


                        this.stopRefreshing();

                    }

                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        alertFunctions.AlertParamEr(this.ApiResData.ErrorData);



                    }
                    else {
                        this.stopRefreshing();
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');

                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);

                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);

                        this.stopRefreshing();
                    }
                }
            );

    }
    onSubmitProvider() {



        this.CurrentSaveIahOrderItemStatusRequest.UserName = AppData.Instance().UserLoginDetails.DisplayName;
        this.CurrentSaveIahOrderItemStatusRequest.ConditionalOperator = 10;
        this.CurrentSaveIahOrderItemStatusRequest.IahOrderCode = this.OrderCode;
        this.CurrentSaveIahOrderItemStatusRequest.IahOrderCode = this.OrderCode;
        this.CurrentSaveIahOrderItemStatusRequest.Timestamp = new Date();
        this.CurrentSaveIahOrderItemStatusRequest.IahOrderItemCode = this.ItemCode;
        this.actorservice.SaveIahOrderItemStatus(this.CurrentSaveIahOrderItemStatusRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {

                    if (this.ApiResData.Result > 0) {
                        //this.GetActorEducationInfoController();
                        //this.GetResourceIdentificationByDateInfoController();
                        // alertFunctions.AlertParam('Saved Successfully.....!');
                        this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
                        //this.isvisible = false;
                       // this.activeModal.close();

                        this.stopRefreshing();
                    }
                    else {
                        alertFunctions.AlertParam("Invalid Operation...!");


                        this.stopRefreshing();

                    }

                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        alertFunctions.AlertParamEr(this.ApiResData.ErrorData);



                    }
                    else {
                        this.stopRefreshing();
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');

                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);

                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);

                        this.stopRefreshing();
                    }
                }
            );

    }
    onSubmitSchedule() {



        this.CurrentSaveIahOrderItemStatusRequest.UserName = AppData.Instance().UserLoginDetails.DisplayName;
        this.CurrentSaveIahOrderItemStatusRequest.ConditionalOperator = 20;
        this.CurrentSaveIahOrderItemStatusRequest.IahOrderCode = this.OrderCode;
        this.CurrentSaveIahOrderItemStatusRequest.Timestamp = new Date(this.parserFormatter.format(this.SelectedDate));
        this.CurrentSaveIahOrderItemStatusRequest.IahOrderItemCode = this.ItemCode;
        this.actorservice.SaveIahOrderItemStatus(this.CurrentSaveIahOrderItemStatusRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {

                    if (this.ApiResData.Result > 0) {
                        //this.GetActorEducationInfoController();
                        //this.GetResourceIdentificationByDateInfoController();
                        // alertFunctions.AlertParam('Saved Successfully.....!');
                        this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
                        //this.isvisible = false;
                      //  this.activeModal.close();

                        this.stopRefreshing();
                    }
                    else {
                        alertFunctions.AlertParam("Invalid Operation...!");


                        this.stopRefreshing();

                    }

                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        alertFunctions.AlertParamEr(this.ApiResData.ErrorData);



                    }
                    else {
                        this.stopRefreshing();
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');

                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);

                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);

                        this.stopRefreshing();
                    }
                }
            );

    }

    onSubmitStatus() {



        this.CurrentSaveIahOrderItemStatusRequest.UserName = AppData.Instance().UserLoginDetails.DisplayName;
        this.CurrentSaveIahOrderItemStatusRequest.ConditionalOperator = 30;
        this.CurrentSaveIahOrderItemStatusRequest.IahOrderCode = this.OrderCode;
        this.CurrentSaveIahOrderItemStatusRequest.Timestamp = new Date(this.parserFormatter.format(this.SelectedDate));
        this.CurrentSaveIahOrderItemStatusRequest.IahOrderItemCode = this.ItemCode;
        this.actorservice.SaveIahOrderItemStatus(this.CurrentSaveIahOrderItemStatusRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {

                    if (this.ApiResData.Result > 0) {
                        //this.GetActorEducationInfoController();
                        //this.GetResourceIdentificationByDateInfoController();
                        // alertFunctions.AlertParam('Saved Successfully.....!');
                        this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
                        //this.isvisible = false;
                        this.activeModal.close();

                        this.stopRefreshing();
                    }
                    else {
                        alertFunctions.AlertParam("Invalid Operation...!");


                        this.stopRefreshing();

                    }

                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        alertFunctions.AlertParamEr(this.ApiResData.ErrorData);



                    }
                    else {
                        this.stopRefreshing();
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');

                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);

                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);

                        this.stopRefreshing();
                    }
                }
            );

    }


  private stopRefreshing() {
    this.loaderService.displayLoader(false);
    this.isRequesting = false;
  }
  private StartRefreshing() {
    this.loaderService.displayLoader(true);
    this.isRequesting = true;
  }





}
